import { render, staticRenderFns } from "./BridgeForm.vue?vue&type=template&id=65c5ea6f&scoped=true&"
import script from "./BridgeForm.vue?vue&type=script&lang=js&"
export * from "./BridgeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c5ea6f",
  null
  
)

export default component.exports